/**
 * Converts a value to a number.
 * If the value is already a number, returns it as-is.
 * If the value is a string, parses it to a number using the specified radix.
 * If the value is undefined or null, returns undefined.
 *
 * @param value - The value to convert (can be string, number, undefined, or null)
 * @param radix - The radix (base) to use when parsing strings (default: 10)
 * @returns The numeric value or undefined
 *
 * @example
 * ```typescript
 * parseStringToNumber('12345');     // 12345
 * parseStringToNumber(12345);       // 12345
 * parseStringToNumber('FF', 16);    // 255
 * parseStringToNumber(undefined);   // undefined
 * parseStringToNumber(null);        // undefined
 * ```
 */
export const parseStringToNumber = (
  value?: string | number | null,
  radix = 10,
): number | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }

  return typeof value === 'string' ? parseInt(value, radix) : value;
};
